import * as Sentry from "@sentry/browser";

const debug = process.env.REACT_APP_ENV === "development";

const configSentry = () =>
  Sentry.init({
    dsn: "https://c3c791a84f13442aacce32fa8937a163@sentry.io/1266505",
    debug
  });

export function logException(ex, context) {
  Sentry.withScope(scope => {
    scope.setTag("event", context.event);
    Sentry.captureException(ex);
  });
  if (debug) {
    /*eslint no-console:0*/
    window && window.console && console.error && console.error(ex);
  }
}

// export function logEvent(eventName, context) {
//   Sentry.captureMessage(eventName, {
//     environment: process.env.REACT_APP_ENV,
//     level: "info",
//     extra: context
//   });
// }

export default configSentry();



// WEBPACK FOOTER //
// ./src/errorLogging.js